var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRepeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9947 4.00001C7.83596 3.99432 4.3664 7.17599 4.01274 11.3197C3.65909 15.4634 6.5393 19.187 10.6389 19.8862C14.7385 20.5853 18.69 18.0267 19.7297 14H17.6487C16.6315 16.8771 13.6168 18.5324 10.6432 17.8465C7.66964 17.1605 5.68464 14.3519 6.03055 11.3199C6.37646 8.28792 8.94308 5.99856 11.9947 6.00001C13.5843 6.00234 15.1061 6.64379 16.2177 7.78002L12.9997 11H19.9997V4.00001L17.6487 6.35002C16.1525 4.84464 14.1172 3.99873 11.9947 4.00001Z",
    fill: "#242731"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRepeat);
export default __webpack_public_path__ + "static/media/arrowRepeat.623c4c05ae9b61f1fbde406b8d7ca340.svg";
export { ForwardRef as ReactComponent };